import axios from "axios";
import { base_url, getConfig } from "../../utils/axiosConfig";
import { useLanguage } from "../../contexts/LanguageContext";

const getProducts = async (data) => {
  console.log(data);
  
  // Build query parameters properly
  const params = new URLSearchParams();
  
  if (data?.brand) params.append('brand', data.brand);
  if (data?.tag) params.append('tags', data.tag);
  if (data?.category) params.append('category', data.category);
  if (data?.minPrice) params.append('price[gte]', data.minPrice);
  if (data?.maxPrice) params.append('price[lte]', data.maxPrice);
  if (data?.sort) params.append('sort', data.sort);
  if (data?.rating) params.append('rating', data.rating);
  
  const queryString = params.toString();
  const url = queryString ? `${base_url}product?${queryString}` : `${base_url}product`;
  
  const response = await axios.get(url);

  if (response.data) {
    return response.data;
  }
};

const getSingleProduct = async (id) => {
  const response = await axios.get(`${base_url}product/${id}`);
  if (response.data) {
    return response.data;
  }
};

const addToWishlist = async (prodId, dynamicConfig) => {
  try {
    // If no dynamic config provided, use the getConfig function to get current token
    const config = dynamicConfig || getConfig();
    
    const response = await axios.put(
      `${base_url}product/wishlist`,
      { prodId },
      config
    );
    if (response.data) {
      return response.data;
    }
  } catch (error) {
    // If it's an authentication error, handle appropriately
    if (error.response && (error.response.status === 401 || error.response.status === 500)) {
      // Check if it's a session invalidation error
      if (error.response.data.message && error.response.data.message.includes("Session invalidated")) {
        // Don't redirect immediately, let the slice handle the error message
        throw error;
      }
      // Check if it's a token expiration error
      else if (error.response.data.message && error.response.data.message.includes("Access token expired")) {
        // Don't redirect immediately, let the slice handle the error message
        throw error;
      } else {
        // For other 401 errors, redirect to login
        localStorage.removeItem("customer");
        window.location.href = "/login";
      }
    }
    // Handle rate limiting errors
    else if (error.response && error.response.status === 429) {
      throw error;
    }
    throw error;
  }
};

// Guest wishlist functionality
const addToWishlistGuest = async (prodId) => {
  // For guest users, we'll just return a success message
  // In a real implementation, you might want to store this in localStorage
  return { message: "Wishlist updated for guest user" };
};

const rateProduct = async (data, dynamicConfig) => {
  try {
    // If no dynamic config provided, use the getConfig function to get current token
    const config = dynamicConfig || getConfig();
    
    const response = await axios.put(`${base_url}product/rating`, data, config);
    if (response.data) {
      return response.data;
    }
  } catch (error) {
    // If it's an authentication error, handle appropriately
    if (error.response && (error.response.status === 401 || error.response.status === 500)) {
      // Check if it's a session invalidation error
      if (error.response.data.message && error.response.data.message.includes("Session invalidated")) {
        // Don't redirect immediately, let the slice handle the error message
        throw error;
      }
      // Check if it's a token expiration error
      else if (error.response.data.message && error.response.data.message.includes("Access token expired")) {
        // Don't redirect immediately, let the slice handle the error message
        throw error;
      } else {
        // For other 401 errors, redirect to login
        localStorage.removeItem("customer");
        window.location.href = "/login";
      }
    }
    throw error;
  }
};

export const productSevice = {
  getProducts,
  addToWishlist,
  addToWishlistGuest,
  getSingleProduct,
  rateProduct,
};